import { render } from "./DropdownApproveModal.vue?vue&type=template&id=4f931f09"
import script from "./DropdownApproveModal.vue?vue&type=script&lang=js"
export * from "./DropdownApproveModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__